// Recovered compiled webpack factory 77278. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    return e
      .split("/")
      .map((e) => encodeURIComponent(e))
      .join("/");
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "encodeURIPath", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
